import PropTypes from "prop-types";
import React from "react";
import { pick } from "lodash";
import Immutable from "immutable";
import Modal from "./base/Modal";
import UserActions from "../actions/UserActions";
import UserPanel from "./UserPanel.jsx";
import uiPrefix from "../utils/UiPrefixUtils";
import { Box, Button } from "@showitinc/showit-wc";

const logout = () => {
  UserActions.logout();
};

class UserModal extends React.Component {
  static propTypes = {
    user: PropTypes.instanceOf(Immutable.Map),
  };

  _logout = (e) => {
    UserActions.logout();
  };

  _closeModal = () => {
    this.props.onHide();
  };

  render() {
    let user = this.props.user;
    let modalProps = pick(this.props, Modal.BASIC_PROPS);
    return (
      <Modal {...modalProps}>
        <Modal.Dialog size="medium">
          <Modal.Dialog.Header closeButton>
            <Modal.Dialog.Title>
              <Box d="flex" dir="row" align="center" className={uiPrefix("user-modal-title")}>
                {this.props.name}
                <Box ml="3">
                  <Button
                    variant="link"
                    lowercase="true"
                    data-e2e={uiPrefix("user-logout-btn")}
                    className={uiPrefix("user-logout-btn")}
                    onSIClick={logout}
                  >
                    Sign Out
                  </Button>
                </Box>
              </Box>
            </Modal.Dialog.Title>
          </Modal.Dialog.Header>
          <Modal.Dialog.Body>
            <UserPanel user={user} close={this._closeModal} />
          </Modal.Dialog.Body>
        </Modal.Dialog>
      </Modal>
    );
  }
}

export default UserModal;
